// assets/component-cart-free-shipping-bar.js
// Keeps the cart-drawer free shipping bar in sync with the cart total. The
// initial state is rendered server-side by snippets/cart-free-shipping-bar.liquid;
// this updates the progress fill and message on every cart change
// (digitaliz:cart:refresh). Threshold is read from the element (cents).
(() => {
  const app = window.Digitaliz;
  if (!app) return;
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.CartFreeShippingBar) return;
  window.DigitalizModules.CartFreeShippingBar = true;

  function update(cart) {
    const total = cart && typeof cart.total_price === "number" ? cart.total_price : 0;

    document.querySelectorAll("[data-cart-fsb]").forEach((bar) => {
      const threshold = Number(bar.dataset.fsbThreshold);
      if (!threshold || threshold <= 0) return;

      const remaining = Math.max(threshold - total, 0);
      const progress = Math.min((total / threshold) * 100, 100);
      const unlocked = total >= threshold;

      bar.style.setProperty("--fsb-progress", `${progress}%`);
      bar.classList.toggle("is-unlocked", unlocked);

      const message = bar.querySelector("[data-fsb-message]");
      if (!message) return;

      if (unlocked) {
        message.textContent = message.dataset.fsbUnlocked || "";
      } else {
        // Rebuild as text + <strong>amount</strong> + text so only the amount is
        // bold. Split on the [[amount]] placeholder the template carries.
        const parts = (message.dataset.fsbRemainingTemplate || "").split("[[amount]]");
        const amount = document.createElement("strong");
        amount.className = "cart-fsb__amount";
        app.setCurrency(amount, remaining);
        message.replaceChildren(
          document.createTextNode(parts[0] || ""),
          amount,
          document.createTextNode(parts[1] || "")
        );
      }
    });
  }

  app.on(app.events.CART_REFRESH, (event) => update(event.detail && event.detail.cart));
})();
